var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"greeting"},[_c('p',[_vm._v("サイトを訪れていただき、ありがとうございます。")]),_c('p',[_vm._v("こちらはシェルを模したポートフォリオサイトになります。")]),_c('p',[_vm._v("ポートフォリオを通じて、UNIXコマンドの体験を提供できればと思い、作成しました。")]),_c('p',[_vm._v("コマンドを楽しむとともに、私のことも知っていただければ、幸いです。")])])
}]

export { render, staticRenderFns }